import React from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { PaymentMethod } from "~/components/payment-method/component";
import { PaymentMethodWithImage } from "~/components/payment-method-with-image/component";
import { WE_ACCEPT_CLASSES } from "~/components/store-details-page/components/we-accept/constants";
import { WeAcceptContainer } from "~/components/store-details-page/components/we-accept/styled";
import { getTestAutomationProps } from "~/helpers/test-automation-props";

import { WeAcceptProps } from "./types";

export const WeAccept: React.FC<WeAcceptProps> = ({ store, weAcceptText }) => {
  if (!store?.paymentOptions?.length && !store?.paymentOptionsWithImages?.length) {
    return null;
  }

  return (
    <WeAcceptContainer {...getTestAutomationProps("we-accept")}>
      <Grid container>
        <Grid
          className={WE_ACCEPT_CLASSES.hideOnMobile}
          size={{
            md: 3,
          }}
        />
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Typography
            variant="h4"
            className={WE_ACCEPT_CLASSES.title}
            {...getTestAutomationProps("title")}
          >
            {weAcceptText}
          </Typography>
          <Box
            className={WE_ACCEPT_CLASSES.paymentMethods}
            {...getTestAutomationProps("payment-methods")}
          >
            {store.paymentOptionsWithImages?.length
              ? store.paymentOptionsWithImages.map((option, index) => {
                  const { image_and_single_line_of_text } = option ?? {};
                  return (
                    <PaymentMethodWithImage
                      key={index}
                      image={image_and_single_line_of_text?.image ?? {}}
                    />
                  );
                })
              : store.paymentOptions?.map((paymentMethod, index) => (
                  <PaymentMethod
                    key={`${index}-${paymentMethod}`}
                    type={paymentMethod ?? ""}
                  />
                ))}
          </Box>
        </Grid>
        <Grid
          className={WE_ACCEPT_CLASSES.hideOnMobile}
          size={{
            md: 3,
          }}
        />
      </Grid>
    </WeAcceptContainer>
  );
};
